export enum ParameterTypes {
    Command = 1,
    CommandResponse,
    Observation
}